// colors used on the website

const colors = {
  primary: '#FF0000',
  secondary: '#000',
  tertiary: '#fff',
  quaternary: ' #282D30',
  backgroundLight: '#FBFBFB',

  // Text
  H2HeadingText: '#20253A',
  SecondaryText: '#74798c',
  NumberText: ' #282D30',
  
   //bar chart
  barChartText: '#9B9EAC',
  barChartGridStroke: '#DEDEDE',
  barChartToolTip: '#C4C4C480',

}

export default colors
